import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './usedEVs.scss';

import UsedEVCatalog from '../../client_customizations/components/UsedEVCatalog/UsedEVCatalog';
import MatchScoreOptions from '../../client_customizations/components/MatchScoreOptions/MatchScoreOptions';
import EvSortControls from '../../components/EvSortControls/EvSortControls';
import ModalComponent from '../../components/ModalUIComponent/ModalUIComponent';
import NewUsedEVFilter from '../../client_customizations/components/NewUsedEVFilter/NewUsedEVFilter';

import { FormattedMessage, useIntl } from 'react-intl';
import { useScrollRestore } from '../../utils/useScrollRestore';

const UsedEVs = ({ usedElectricVehicles, ip, uuid, page, history }) => {
  const intl = useIntl();

  useScrollRestore(history, ['/used-vehicles']);

  useEffect(() => {
    document.title = process.env.REACT_APP_PAGES_USED_VEHICLES_TITLE;
  });

  const time = new Date().toLocaleString();
  const mobile = window.innerWidth < 720;

  const renderOptions = (mobile) => (
    <>
      <MatchScoreOptions
        electricVehicles={usedElectricVehicles}
        mobile={mobile}
        age={'used'}
      />
    </>
  );

  return (
    <section className="container-fluid" id="EVs">
      <div className="container">
        <div className="row mb-3">
          <div className="col-sm-12 text-center">
            <h1 className="header">
              <FormattedMessage
                id="evsCatalog.title"
                defaultMessage="Discover electric vehicles"
                description="Electric Vehicles"
              />
            </h1>
            <h2 className="small-centered mb-bottom mb-top sub-header">
              <FormattedMessage
                id="evsCatalog.subtitle"
                defaultMessage="There are more electric vehicles than ever before. Find yours, today."
                description="Description of Colton Recharged"
                values={{
                  lineBreak: <br />,
                }}
              />
            </h2>
          </div>
        </div>
        <div className="newused-row">
          {!mobile ? null : (
            <div style={{ display: 'inline' }}>
              <NewUsedEVFilter value={'used'} />
            </div>
          )}
        </div>
        <div className="evsort-row">
          {mobile ? <EvSortControls mobile={mobile} /> : null}
        </div>
        <div className="row">
          <div className="col-sm-12 d-block d-lg-none text-center">
            <ModalComponent
              buttonText={
                intl.formatMessage
                  ? intl.formatMessage({
                      id: 'evs.buttonMatchScoreAndFilters',
                      defaultMessage: 'Adjust filters',
                    })
                  : 'Adjust filters'
              }
              titleText={
                intl.formatMessage
                  ? intl.formatMessage({
                      id: 'evs.matchScoreAndFilters',
                      defaultMessage: 'Filters',
                    })
                  : 'Filters'
              }
              submitText={
                intl.formatMessage
                  ? intl.formatMessage({
                      id: 'applyFilters',
                      defaultMessage: 'Apply filters',
                    })
                  : 'Apply filters'
              }
              disclaimerText={
                <FormattedMessage
                  id="evs.thirdParty"
                  defaultMessage="We do not endorse or recommend any specific vehicle or car manufacturer. Vehicles displayed may not reflect actual availability."
                  description="Vehicles Disclaimer"
                  values={{
                    company: process.env.REACT_APP_FULL_COMPANY_NAME,
                  }}
                />
              }
            >
              {renderOptions(mobile)}
            </ModalComponent>
            <br />
          </div>
          {!mobile && (
            <div className="col-xl-3 col-lg-4 d-none d-lg-block">
              {renderOptions(mobile)}
            </div>
          )}
          <div
            id="electric-vehicles-catalog"
            aria-live="polite"
            aria-atomic="true"
            role="region"
            style={{ position: 'absolute', top: '-9999px' }}
          >
            <span>Results have been updated as of {time}.</span>
          </div>
          <div
            className="col-xl-9 col-lg-8 col-sm-12"
            style={{ padding: 0, flexDirection: 'column', display: 'flex' }}
          >
            <div className="col pull-right">
              {!mobile ? <EvSortControls mobile={mobile} /> : null}
            </div>
            <UsedEVCatalog
              vehicles={usedElectricVehicles}
              hasEvDetails
              hasIncentivesAndMatchScore
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default UsedEVs;

UsedEVs.propTypes = {
  electricVehicles: PropTypes.array,
  ip: PropTypes.string,
  uuid: PropTypes.string,
};
